<template>
  <div id="app">
    <Header/>
    <div id="nav">
      <template v-if="logged && privacyOK">
        <!-- <router-link to="/">Home</router-link> -->
        <router-link to="/machines">Machines</router-link>
        <router-link to="/spareparts"> | Spare Parts</router-link>
        <router-link to="/assistance"> | Tickets/Assistance</router-link>
        <router-link to="/reminders"> | Reminders</router-link>
        <!-- <router-link to="/contracts"> | Contracts</router-link> -->
        <router-link to="/arch"> | Campaign Archive</router-link>
        <router-link v-if="m" to="/users"> | Users</router-link>
        <router-link v-if="mm" to="/siteadmin"> | Site Admin</router-link>
        <router-link v-if="mm" to="/logs"> | Logs</router-link>
        <router-link v-if="mm" to="/logs2"> | Logs 2</router-link>
        <router-link v-if="mm" to="/overrides"> | Overrides</router-link>
        <router-link to="/support"> | Support</router-link>
      </template>
    </div>
    <router-view :key="$route.name"/>
  </div>
</template>

<script>
import Header from './components/Header.vue'
export default {
  name: 'App',
  components: {
    Header
  },
  computed: {
    mm(){ // Master Marsilli
      // console.log("mm ?",this.$store.getters.master ,this.$store.getters.marsilli)
      let master = this.$store.getters.master
      let marsilli = this.$store.getters.marsilli
      return master && marsilli
    },
    m(){ // Master
      // console.log("mm ?",this.$store.getters.master ,this.$store.getters.marsilli)
      let master = this.$store.getters.master
      return master
    },
    logged(){
      // console.log("logged app",this.$store.getters.logged)
      return this.$store.getters.logged
    },
    privacyOK(){
        return this.$store.getters.privacyOK
    },
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#nav {
  padding: 30px;
  height: 9vh; /* 84px; */
  min-height: 9vh; /* 84px; */
  max-height: 9vh; /* 84px; */
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #9A240D;
    }
  }
}
</style>
